/* global google */

export default {
    init() {
        // JavaScript to be fired on all pages

        // ScrollTo Menu
        $('.js-scrollTo').on('click', function () { // Au clic sur un élément
            var target = $(this).attr('href'); // Page cible
            var speed = 750; // Durée de l'animation (en ms)
            $('html, body').animate({ scrollTop: $(target).offset().top - 100 }, speed); // Go
            return false;
        });


        /************ HEADER ************/
        //MENU FIXED
        var stickyTop = $('#header').offset().top + 100;
        $(window).on('scroll', function () {
            if ($(window).scrollTop() >= stickyTop) {
                $('#header').addClass('sticky');
            } else {
                $('#header').removeClass('sticky');
            }
        });

        // Menu Mobile
        function showMenuMobile() {
            var documentWidth = $(window).innerWidth();
            if (documentWidth <= 991) {
                $('#blockMenu').addClass('navbar-collapse').addClass('collapse');
                $('#blockMenu a').on('click', function () {
                    $('button.navbar-toggler').trigger('click');
                });
            } else {
                $('#blockMenu').removeClass('navbar-collapse').removeClass('collapse');
            }
        }
        showMenuMobile();
        $(window).resize(function () {
            showMenuMobile();
        });


        // Image Scale Init
        function imageScaleLoaded() {
            $('img.scale, img.lazy').lazy({
                beforeLoad: function(element) {
                    var imageSrc = element.data('src');
                    console.log('image "' + imageSrc + '" is about to be loaded');
                },
                afterLoad: function (element) {
                    var imageSrc = element.data('src');
                    console.log('image "' + imageSrc + '" was loaded successfully');
                    element.imageScale();
                },
            });
        }

        imageScaleLoaded();


        /************ FOOTER ************/
        $('#mailjetSubscriptionForm input[type="submit"]').val('OK');



        /************ SINGLE SITE ************/

        //Google Map
        function initMap($el) {

            // Find marker elements within map.
            var $markers = $el.find('.marker');

            // Create gerenic map.
            var mapArgs = {
                zoom: $el.data('zoom') || 16,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            };
            var map = new google.maps.Map($el[0], mapArgs);

            // Add markers.
            map.markers = [];
            $markers.each(function () {
                initMarker($(this), map);
            });

            // Center map based on markers.
            centerMap(map);

            // Return map instance.
            return map;
        }

        /**
        * initMarker
        *
        * Creates a marker for the given jQuery element and map.
        *
        * @date    22/10/19
        * @since   5.8.6
        *
        * @param   jQuery $el The jQuery element.
        * @param   object The map instance.
        * @return  object The marker instance.
        */
        function initMarker($marker, map) {

            // Get position from marker.
            var lat = $marker.data('lat');
            var lng = $marker.data('lng');
            var latLng = {
                lat: parseFloat(lat),
                lng: parseFloat(lng),
            };

            // Create marker instance.
            var marker = new google.maps.Marker({
                position: latLng,
                map: map,
            });

            // Append to reference for later use.
            map.markers.push(marker);

            // If marker contains HTML, add it to an infoWindow.
            if ($marker.html()) {

                // Create info window.
                var infowindow = new google.maps.InfoWindow({
                    content: $marker.html(),
                });

                // Show info window when marker is clicked.
                google.maps.event.addListener(marker, 'click', function () {
                    infowindow.open(map, marker);
                });
            }
        }

        /**
        * centerMap
        *
        * Centers the map showing all markers in view.
        *
        * @date    22/10/19
        * @since   5.8.6
        *
        * @param   object The map instance.
        * @return  void
        */
        function centerMap(map) {

            // Create map boundaries from all map markers.
            var bounds = new google.maps.LatLngBounds();
            map.markers.forEach(function (marker) {
                bounds.extend({
                    lat: marker.position.lat(),
                    lng: marker.position.lng(),
                });
            });

            // Case: Single marker.
            if (map.markers.length == 1) {
                map.setCenter(bounds.getCenter());

                // Case: Multiple markers.
            } else {
                map.fitBounds(bounds);
            }
        }

        var map;

        $('.acf-map').each(function () {
            console.log(map);
            map = initMap($(this));
        });


        $('#carouselPhotosSites').carousel();

        // Slick Full Images Single Voyages
        $('#blockFullImages').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            asNavFor: '#blockNavImages',
        });

        // Slick Nav Images Single Voyages
        $('#blockNavImages').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            asNavFor: '#blockFullImages',
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            arrows: true,
            infinite: true,
        });

        // ImgScale on Scroll
        $(window).scroll(function () {
            imageScaleLoaded();
            $('img.scale').imageScale();
        });





    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js